import { render } from "./TwoFactorVerify.vue?vue&type=template&id=321560ae&scoped=true"
import script from "./TwoFactorVerify.vue?vue&type=script&lang=js"
export * from "./TwoFactorVerify.vue?vue&type=script&lang=js"

import "./TwoFactorVerify.vue?vue&type=style&index=0&id=321560ae&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-321560ae"]])

export default __exports__